<template>
  <div
    class="item van-content" data-tieu-van="0" style="text-align: center"
    @click="$emit('onClickTieuVan', index)"
  >
    <ul class="tieu-van">
      <li>
        Lưu niên năm:
        <span style="font-weight: bold">{{ luunien.year }}</span>
      </li>
      <li>
        <item-can :data="luunien"/>
      </li>
      <li>
        <item-chi :data="luunien"/>
      </li>
      <li :class="`capitalize text-bold color_${luunien.nguhanhnapam.toLowerCase()}`">{{ luunien.napam.toLowerCase() }}</li>
      <li>
        <item-than-sat
          :cattinh="luunien.cattinh"
          :hungtinh="luunien.hungtinh"
          :custom-height="customHeightLn"
        />
      </li>
      <template v-if="tieuvan">
        <li>
          Tiểu vận tuổi:
          <span style="font-weight: bold">{{ tieuvan.tuoi }}</span>
        </li>
        <li>
          <item-can :data="tieuvan"/>
        </li>
        <li>
          <item-chi :data="tieuvan"/>
        </li>
        <li :class="`capitalize text-bold color_${tieuvan.nguhanhnapam.toLowerCase()}`">{{ tieuvan.napam.toLowerCase() }}</li>
        <li>
          <item-than-sat
            :cattinh="tieuvan.cattinh"
            :hungtinh="tieuvan.hungtinh"
            :custom-height="customHeightTv"
          />
        </li>
      </template>
      <item-dung-hi-ky class="dung-hi-ky" />
    </ul>
<!--    <button type="button" class="btn btn-success" onclick="cachTinhDungThan(1)">Xem chi tiết</button>-->
  </div>

</template>

<script>
import ItemCan from './ItemCan'
import ItemChi from './ItemChi'
import ItemThanSat from './ItemThanSat'
import ItemDungHiKy from './ItemDungHiKy'
export default {
  name: 'ItemTieuVan',
  components: {
    ItemCan,
    ItemChi,
    ItemThanSat,
    ItemDungHiKy
  },
  props: {
    index: {
      type: [String, Number],
      default: 1
    },
    luunien: {
      type: Object,
      default: () => {}
    },
    tieuvan: {
      type: Object,
      default: () => {}
    },
    customHeightLn: {
      type: String,
      default: null
    },
    customHeightTv: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>
  .box-2 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
</style>
